<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange" @row-save="handleSave" @row-update="handleUpdate"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SHOP_GOODS_ADD" @click.stop="handleAdd()">新增</el-button>
          <el-button type="success" icon="el-icon-sort-up" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SHOP_GOODS_EDIT" @click.stop="handleInOut('SOLD_IN')">上架</el-button>
          <el-button type="danger" icon="el-icon-sort-down" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SHOP_GOODS_EDIT" @click.stop="handleInOut('SOLD_OUT')">下架</el-button>
          <el-button type="warning" icon="el-icon-check" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SHOP_GOODS_DEL"
            @click.stop="handleDel('DELETE_OPTION', '逻辑删除')">删除</el-button>
          <el-button type="danger" icon="el-icon-check" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SHOP_GOODS_DEL_TRUE"
            @click.stop="handleDel('DELETE_OPTION', '物理删除')">物理删除</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="success" icon="el-icon-view" size="small" plain
            @click.stop="handleDetail(scope.row, scope.index)">查看</el-button>
          <el-button type="warning" icon="el-icon-edit" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SHOP_GOODS_EDIT"
            @click.stop="handleEdit(scope.row, scope.index)">编辑</el-button>
        </template>
        <template slot-scope="scope" slot="brandId">
          <el-tag v-if="null != scope.row.brandName">{{ scope.row.brandName }}</el-tag>
        </template>
        <template slot-scope="scope" slot="firstClassify">
          <el-tag v-if="null != scope.row.firstClassifyName">{{ scope.row.firstClassifyName }}</el-tag>
        </template>
        <template slot-scope="scope" slot="secondClassify">
          <el-tag v-if="null != scope.row.secondClassifyName">{{ scope.row.secondClassifyName }}</el-tag>
        </template>
        <template slot-scope="scope" slot="firstClassifyForm">
          <el-select v-model="firstClassify" placeholder="请选择一级分类" required @change="choseSecondClassify" value-key="id">
            <el-option v-for="firstClassify in firstClassifys" :key="firstClassify.id" :label="firstClassify.name"
              :value="firstClassify"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="secondClassifyForm">
          <el-select v-model="secondClassify" placeholder="请选择二级分类" required value-key="id">
            <el-option v-for="secondClassify in secondClassifys" :key="secondClassify.id" :label="secondClassify.name"
              :value="secondClassify"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="brandIdForm">

          <el-form-item prop="brand">
            <el-select v-model="brand" placeholder="请选择商品品牌" required value-key="id">
              <el-option v-for="brand in brands" :key="brand.id" :label="brand.name" :value="brand"></el-option>
            </el-select>
          </el-form-item>

        </template>
        <template slot-scope="scope" slot="describeImgsForm">
          <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList" :http-request="fnUploadDescribeImgs" :show-file-list="false">
            <div v-if="'' != describeImgs" class="el-upload el-upload--picture-img">
              <img v-for="describeImg of describeImgs" :src="describeImg" style="width: 200px;" />
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="wheelsImgsForm">
          <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
            :file-list="fileList" :http-request="fnUploadWheelsImgs" :show-file-list="false">
            <div v-if="'' != wheelsImgs" class="el-upload el-upload--picture-img">
              <img v-for="wheelsImg of wheelsImgs" :src="wheelsImg" style="width: 200px;" />
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { shopGoodsTableOption } from "@/const/salesCloud/shopGoodsOption";
import {
  findShopGoods,
  addShopGoods,
  editShopGoods,
  delShopGoods,
  shopGoodsInOut
} from "@/api/salesCloud/shopGoods";
import { findBrandAll } from "@/api/sales/brand";
import { findClassify } from "@/api/sales/classify";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
  name: "shopGoods",
  components: {},
  data() {
    return {
      tableOption: shopGoodsTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      brands: [],
      brand: {},
      firstClassifys: [],
      firstClassify: {},
      secondClassifys: [],
      secondClassify: {},
      describeImgs: [],
      wheelsImgs: [],
      fileList: []
    };
  },
  created() {
    this.handleList();
    findBrandAll().then(res => {
      let data = JSON.parse(res.data);
      this.brands = data.rows;
    });
    findClassify().then(res => {
      let data = JSON.parse(res.data);
      this.firstClassifys = data;
    });
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    handleInOut(option) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认此项操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            if (option == row.goodsStatus) {
              this.$message({
                showClose: true,
                message: "请选择状态一致的商品进行上下架操作",
                type: "error"
              });
              return;
            }
            ids.push(row.id);
          }
          let obj = {
            option: option
          };
          shopGoodsInOut(ids, obj)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => { });
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name);
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            this.describeImgs.push(results.res.requestUrls[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    async fnUploadWheelsImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name);
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            this.wheelsImgs.push(results.res.requestUrls[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    choseSecondClassify() {
      let parma = {
        superiorId: this.firstClassify.id
      };
      findClassify(parma).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifys = data;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findShopGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findShopGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findShopGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findShopGoods(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    handleDetail(row, index) {
      if (null != row.brandId) {
        this.brand = {
          id: row.brandId
        };
      }
      if (null != row.firstClassifyId) {
        this.firstClassify = {
          id: row.firstClassifyId
        };
        this.choseSecondClassify();
      }
      if (null != row.secondClassifyId) {
        this.secondClassify = {
          id: row.secondClassifyId
        };
      }
      this.describeImgs = row.describeImgs;
      this.wheelsImgs = row.wheelsImgs;
      this.$refs.crud.rowView(row, index);
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      if (null != row.brandId) {
        this.brand = {
          id: row.brandId
        };
      }
      if (null != row.firstClassifyId) {
        this.firstClassify = {
          id: row.firstClassifyId
        };
        this.choseSecondClassify();
      }
      if (null != row.secondClassifyId) {
        this.secondClassify = {
          id: row.secondClassifyId
        };
      }
      this.describeImgs = row.describeImgs;
      this.wheelsImgs = row.wheelsImgs;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findShopGoods(parmas).then(res => {
        let data = JSON.parse(res.data);
        console.log(res);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.brandId = this.brand.id;
      row.firstClassifyId = this.firstClassify.id;
      row.secondClassifyId = this.secondClassify.id;
      row.describeImgs = this.describeImgs;
      row.wheelsImgs = this.wheelsImgs;
      console.log(row);
      addShopGoods(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delShopGoods(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => { });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.brandId = this.brand.id;
      row.firstClassify = this.firstClassify.id;
      row.secondClassify = this.secondClassify.id;
      row.describeImgs = this.describeImgs;
      row.wheelsImgs = this.wheelsImgs;
      editShopGoods(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
